<template>
  <el-dialog custom-class="connection-setting-container dialog-size-middle"
             :title="'接続先' + (selectedConnectionId ? '編集' : '追加')"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="connection-setting-main-container">
      <form-container ref="connectionSettingForm">
        <form-item-container label="タイプ">
          <field-container v-if="!selectedConnectionId">
            <field-select name="type" v-model="connectionType"
                          placeholder="タイプを選択してください" validate="required"
                          validateLabel="タイプ" @change="onChangeConnectionType">
              <el-option v-for="tmpConnectionType in CONNECTION_TYPES"
                         :label="tmpConnectionType.name"
                         :value="tmpConnectionType.type"></el-option>
            </field-select>
          </field-container>
          <span v-else>{{getConnectionTypeName(connection.type)}}</span>
        </form-item-container>

        <form-item-container label="接続先名">
          <field-container>
            <field-input name="connection_name"
                         v-model="connection.connectionName" placeholder=""
                         validate="required|max:100"
                         validateLabel="接続先名"></field-input>
          </field-container>
        </form-item-container>

        <form-item-container label="ホスト">
          <field-container>
            <field-input name="connection_host" v-model="connection.host"
                         placeholder="skyfox.sxi.co.jp"
                         validate="required" validateLabel="ホスト"></field-input>
          </field-container>
        </form-item-container>

        <form-item-container label="ポート">
          <field-container>
            <field-input name="connection_port" v-model="connection.port"
                         placeholder="" validate="required|integer"
                         validateLabel="ポート"></field-input>
          </field-container>
        </form-item-container>

        <form-item-container label="ユーザID">
          <field-container>
            <field-input name="connection_user" v-model="connection.user"
                         placeholder="" validate="required"
                         validateLabel="ユーザID"></field-input>
          </field-container>
        </form-item-container>

        <form-item-container label="パスワード">
          <field-container>
            <field-input name="connection_password" type="password"
                         v-model="connection.password" placeholder=""
                         validate="" validateLabel="パスワード"></field-input>
          </field-container>
        </form-item-container>

        <template v-if="getConnectionServerType(connection.type) === 'db'">
          <form-item-container label="データベース">
            <field-container>
              <field-input name="connection_database"
                           v-model="connection.database" placeholder=""
                           validate="required|max:100"
                           validateLabel="データベース"></field-input>
            </field-container>
          </form-item-container>
        </template>

        <template v-if="getConnectionServerType(connection.type) === 'db'">
          <form-item-container label="SSL">
            <field-container>
              <field-radio-group v-model="connection.sslEnabled"
                                 label="connection_ssl_enabled"
                                 name="connection_ssl_enabled"
                                 :options="[{label: '有効', value: true}, {label: '無効', value: false}]"></field-radio-group>
            </field-container>

            <field-container label="SSLモード"
                             v-if="connection.sslEnabled !== false">
              <field-select v-model="connection.sslMode"
                            label="connection_ssl_enabled"
                            name="connection_ssl_enabled"
                            :options="[{label: 'SSLでの接続を優先', value: 'prefer'}, {label: 'SSLでの接続を必須', value: false}]">
                <el-option label="優先(SSL接続を優先)" value="prefer"></el-option>
                <el-option label="必須(暗号化のみ)" value="require"></el-option>
                <el-option label="必須(サーバー認証を行う)" value="verify-ca"></el-option>
                <el-option label="必須(サーバーとクライアントの相互認証を行う)"
                           value="verify-full"></el-option>
              </field-select>
            </field-container>

            <field-container label="CA証明書"
                             v-if="connection.sslMode === 'verify-ca' || connection.sslMode === 'verify-full'"
                             class="connection-file-container"
                             :class="{ 'has-error': sslCaFileValidateError }">
              <field-file-input name="connection_ssl_ca"
                                v-model="connection.sslCaFile"
                                style="width: 100%;"></field-file-input>
              <span class="error-message"><strong>CA証明書を選択してください</strong></span>
            </field-container>

            <field-container label="クライアント証明書"
                             v-if="connection.sslMode === 'verify-full'"
                             class="connection-file-container"
                             :class="{ 'has-error': sslCertFileValidateError }">
              <field-file-input name="connection_ssl_cert"
                                v-model="connection.sslCertFile"
                                style="width: 100%;"></field-file-input>
              <span
                class="error-message"><strong>クライアント証明書を選択してください</strong></span>
            </field-container>

            <field-container label="クライアント秘密鍵"
                             v-if="connection.sslMode === 'verify-full'"
                             class="connection-file-container"
                             :class="{ 'has-error': sslKeyFileValidateError }">
              <field-file-input name="connection_ssl_key"
                                v-model="connection.sslKeyFile"
                                style="width: 100%;"></field-file-input>
              <span
                class="error-message"><strong>クライアント秘密鍵を選択してください</strong></span>
            </field-container>
          </form-item-container>
        </template>

        <template v-if="connection.type === 'sftp'">
          <form-item-container label="SSH秘密鍵">
            <field-container class="connection-file-container"
                             :class="{ 'has-error': privateKeyFileValidateError }">
              <field-file-input name="connection_private_key"
                                v-model="connection.privateKeyFile"
                                style="width: 100%;"></field-file-input>
            </field-container>
            <span class="error-message"><strong>SSH秘密鍵を選択してください</strong></span>
          </form-item-container>
        </template>
      </form-container>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="info" @click="onClickConnectionTest">接続テスト</el-button>
      <el-button type="primary" @click="onUpdateConnection"
                 v-if="connection.connectionId && connection.connectionId.length > 0">OK</el-button>
      <el-button type="primary" @click="onCreateConnection"
                 v-else>OK</el-button>
    </span>
  </el-dialog>
</template>

<script lang="js">
import CommonUtil from '../../../utils/common'
import ApiApiClient from '../../../api/api'
import WebApiClient from '../../../api/web'
import {Code} from '../../../api/base'
import MessageBox from '../../../utils/message-box'

export default {
  name: 'ConnectionSettingDialogCmp',
  components: {},
  props: {
    selectedConnectionId: null
  },
  computed: {
    CONNECTION_TYPES () {
      return [
        {
          type: 'postgresql',
          name: 'PostgreSQL',
          defaultPort: '5432',
          serverType: 'db'
        }, {
          type: 'mysql',
          name: 'MySQL',
          defaultPort: '3306',
          serverType: 'db'
        }, {
          type: 'redshift',
          name: 'Redshift',
          defaultPort: '5439',
          serverType: 'db'
        }, {
          type: 'ftp',
          name: 'FTP',
          defaultPort: '21',
          serverType: 'file'
        }, {
          type: 'sftp',
          name: 'SFTP',
          defaultPort: '22',
          serverType: 'file'
        }]
    }
  },
  data () {
    return {
      connection: {
        connectionId: null,
        connectionName: '',
        type: '',
        host: '',
        port: '',
        user: '',
        password: '',
        database: '',
        sslEnabled: false,
        sslMode: 'disable',
        sslCertFile: [],
        sslKeyFile: [],
        sslCaFile: [],
        privateKeyFile: []
      },
      connectionType: '',
      visible: true,
      sslCertFileValidateError: false,
      sslKeyFileValidateError: false,
      sslCaFileValidateError: false,
      privateKeyFileValidateError: false

    }
  },
  mounted () {
    if (CommonUtil.isNotEmpty(this.selectedConnectionId)) {
      WebApiClient.getConnection(this, this.selectedConnectionId).then((response) => {
        if (response.data.code === Code.SUCCESS) {
          let connection = response.data.result
          connection.sslCertFile = this.keyStr2File(connection.sslCert, connection.sslCertName)
          connection.sslKeyFile = this.keyStr2File(connection.sslKey, connection.sslKeyName)
          connection.sslCaFile = this.keyStr2File(connection.sslCa, connection.sslCaName)
          connection.privateKeyFile = this.keyStr2File(connection.privateKey, connection.privateKeyName)
          if (CommonUtil.isEmpty(connection.sslMode)) {
            connection.sslMode = 'disable'
          }
          if (CommonUtil.isEmpty(connection.sslEnabled)) {
            connection.sslEnabled = false
            if (CommonUtil.isNotEmpty(connection.sslMode)) {
              if (connection.sslMode !== 'disable') {
                connection.sslEnabled = true
              }
            }
          }
          delete connection.sslCert
          delete connection.sslCertName
          delete connection.sslKey
          delete connection.sslKeyName
          delete connection.sslCa
          delete connection.sslCaName
          delete connection.privateKey
          delete connection.privateKeyName
          this.connection = connection
          this.connectionType = this.connection.type
        } else {
          this.visible = false
        }
        this.$forceUpdate()
      })
    }
  },
  watch: {
    'connection.sslEnabled' (newSslEnabled) {
      if (!newSslEnabled) {
        this.$set(this.connection, 'sslMode', 'disable')
        this.connection.sslCaFile = []
        this.connection.sslCertFile = []
        this.connection.sslKeyFile = []
        this.sslCertFileValidateError = false
        this.sslKeyFileValidateError = false
        this.sslCaFileValidateError = false
      } else {
        if (this.connection.sslMode === 'disable') {
          this.$set(this.connection, 'sslMode', 'require')
        }
      }
      this.$forceUpdate()
    },
    'connection.sslMode' (newSslMode) {
      if (newSslMode !== 'verify-full') {
        this.connection.sslCertFile = []
        this.connection.sslKeyFile = []
        this.sslCertFileValidateError = false
        this.sslKeyFileValidateError = false
        if (newSslMode !== 'verify-ca') {
          this.connection.sslCaFile = []
          this.sslCaFileValidateError = false
        }
      }
      this.$forceUpdate()
    },
    'connection.sslCertFile' (newSslCertFile) {
      if (this.connection.sslMode === 'verify-full') {
        this.sslCertFileValidateError = CommonUtil.isEmpty(newSslCertFile)
        this.$forceUpdate()
      }
    },
    'connection.sslKeyFile' (newSslKeyFile) {
      if (this.connection.sslMode === 'verify-full') {
        this.sslKeyFileValidateError = CommonUtil.isEmpty(newSslKeyFile)
        this.$forceUpdate()
      }
    },
    'connection.sslCaFile' (newSslCaFile) {
      if (this.connection.sslMode === 'verify-ca' || this.connection.sslMode === 'verify-full') {
        this.sslCaFileValidateError = CommonUtil.isEmpty(newSslCaFile)
        this.$forceUpdate()
      }
    }
  },

  methods: {
    keyStr2File (key, name) {
      if (CommonUtil.isEmpty(key) || CommonUtil.isEmpty(name)) return []

      let blob = new Blob([key])
      blob = Object.assign(blob, {
        lastModified: new Date(),
        name: name
      })
      return [
        {
          status: 'success',
          name: name,
          size: key.length,
          percentage: 100,
          uid: null,
          raw: blob
        }]
    },

    onChangeConnectionType (type) {
      if (CommonUtil.isEmpty(this.connection.connectionId)) {
        this.connectionType = type
        let connectionType = this.CONNECTION_TYPES.filter(
          (connectionType) => {
            return connectionType.type === type
          })[0]
        this.connection = {
          connectionId: null,
          connectionName: this.connection.connectionName,
          type: type,
          host: '',
          port: connectionType.defaultPort,
          user: '',
          password: '',
          database: '',
          sslEnabled: this.getConnectionServerType(type) === 'db',
          sslMode: this.getConnectionServerType(type) === 'db' ? 'require' : 'disable',
          sslCertFile: [],
          sslKeyFile: [],
          sslCaFile: [],
          privateKeyFile: []
        }
      }
      this.sslCertFileValidateError = false
      this.sslKeyFileValidateError = false
      this.sslCaFileValidateError = false
      this.privateKeyFileValidateError = false
      this.$forceUpdate()
    },

    getConnectionTypeName (type) {
      if (CommonUtil.isEmpty(type)) return ''
      let connectionType = this.CONNECTION_TYPES.filter((connectionType) => {
        return connectionType.type === type
      })[0]
      return connectionType.name
    },

    getConnectionServerType (type) {
      if (CommonUtil.isEmpty(type)) return ''
      let connectionType = this.CONNECTION_TYPES.filter((connectionType) => {
        return connectionType.type === type
      })[0]
      return connectionType.serverType
    },

    onClickSelect () {
      this.visible = false
    },

    onClickConnectionTest () {
      this.isValid().then((result) => {
        if (result) {
          ApiApiClient.connectionTest(this, this.connection).then((response) => {
            if (response.data.code === Code.SUCCESS) {
              MessageBox.alert(this, '接続に成功しました。').catch(() => {
              })
            }
          })
        }
      })
    },

    onCreateConnection () {
      this.isValid().then((result) => {
        if (result) {
          WebApiClient.postConnections(this, this.connection).then((response) => {
            if (response.data.code === Code.SUCCESS) {
              this.visible = false
            }
          })
        }
      })
    },

    onUpdateConnection () {
      this.isValid().then((result) => {
        if (result) {
          WebApiClient.putConnection(this, this.connection.connectionId, this.connection).then((response) => {
            if (response.data.code === Code.SUCCESS) {
              this.visible = false
            }
          })
        }
      })
    },

    isValid () {
      this.sslCertFileValidateError = false
      this.sslKeyFileValidateError = false
      this.sslCaFileValidateError = false
      this.privateKeyFileValidateError = false

      if (this.getConnectionServerType(this.connection.type) === 'db') {
        if (this.connection.sslMode === 'verify-ca' || this.connection.sslMode === 'verify-full') {
          if (CommonUtil.isEmpty(this.connection.sslCaFile)) {
            this.sslCaFileValidateError = true
          }
        }
        if (this.connection.sslMode === 'verify-full') {
          if (CommonUtil.isEmpty(this.connection.sslCertFile)) {
            this.sslCertFileValidateError = true
          }
          if (CommonUtil.isEmpty(this.connection.sslKeyFile)) {
            this.sslKeyFileValidateError = true
          }
        }
      }
      return new Promise((resolve) => {
        this.$refs.connectionSettingForm.$validator.validateAll().then((result) => {
          resolve(!this.sslCertFileValidateError && !this.sslKeyFileValidateError && !this.sslCaFileValidateError &&
                                !this.privateKeyFileValidateError && result === true)
        })
      })
    }
  }
}
</script>

<style type="scss" scoped>
  .connection-setting-main-container {
    display: flex;
    height: 480px;
    overflow-y: auto;
    flex-shrink: 0;
    flex-grow: 0;
  }

  .connection-setting-main-container > .form {
    width: 100%;
  }

  .field.connection-file-container > > > .field-content {
    flex-direction: column;
    align-items: start;
  }
</style>



// WEBPACK FOOTER //
// src/components/connection/dialogs/connection-setting.vue